import { render, staticRenderFns } from "./SwiperOccupations.vue?vue&type=template&id=4f8e95f0&"
import script from "./SwiperOccupations.vue?vue&type=script&lang=js&"
export * from "./SwiperOccupations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports